<privacy-policy-banner></privacy-policy-banner>
<div class="ez-section-card" id="ez-privacy-policy">
    <div class="ez-technology-platform-section">
        <div class="technologies-section">
            <privacy-policy-list></privacy-policy-list>
        </div>
    </div>
</div>
